// A4 portrait page size in millimetres. Overlay positions are mm from top-left.
export const A4_WIDTH_MM = 210
export const A4_HEIGHT_MM = 297

// Single source of truth for the overlay fields: label + sample text (for the
// visual editor chips) + default position/style. Keys must match the blade
// ($defaults in rtgs-overlay.blade.php) and the backend overlay_config.
export const COORD_FIELDS = [
  { key: "branch_name", label: "Branch Name", sample: "Mirpur Branch" },
  { key: "date", label: "Date", sample: "22062026" },
  {
    key: "remitter_account_number",
    label: "Remitter Account Number",
    sample: "1234567890123",
  },
  { key: "remitter_name", label: "Remitter Name", sample: "Sample Company Ltd." },
  { key: "remitter_mobile", label: "Remitter Mobile", sample: "01700000000" },
  { key: "purpose", label: "Purpose", sample: "Vehicle Import Payment" },
  {
    key: "beneficiary_account_name",
    label: "Beneficiary A/C Name",
    sample: "ABC Importers Ltd.",
  },
  {
    key: "beneficiary_name",
    label: "Beneficiary Name",
    sample: "ABC Importers Ltd.",
  },
  {
    key: "beneficiary_account_number",
    label: "Beneficiary Account Number",
    sample: "9876543210",
  },
  {
    key: "beneficiary_bank_name",
    label: "Beneficiary Bank Name",
    sample: "Sample Bank PLC",
  },
  {
    key: "beneficiary_routing_number",
    label: "Beneficiary Routing Number",
    sample: "090260187",
  },
  {
    key: "beneficiary_branch_name",
    label: "Beneficiary Branch Name",
    sample: "Main Branch",
  },
  { key: "amount_figures", label: "Amount (Figures)", sample: "500000" },
  {
    key: "amount_words",
    label: "Amount (Words)",
    sample: "Five Lakh Taka Only",
  },
]

export const DEFAULT_COORDS = {
  branch_name: { left: 20, top: 21, font_size: 9, letter_spacing: 0, bold: false },
  date: { left: 153, top: 14, font_size: 9, letter_spacing: 18, bold: false },
  remitter_account_number: { left: 48, top: 61.5, font_size: 9, letter_spacing: 40, bold: false },
  remitter_name: { left: 48, top: 67, font_size: 9, letter_spacing: 0, bold: false },
  remitter_mobile: { left: 48, top: 73, font_size: 9, letter_spacing: 48, bold: false },
  purpose: { left: 48, top: 79, font_size: 9, letter_spacing: 0, bold: false },
  beneficiary_account_name: { left: 48, top: 90, font_size: 9, letter_spacing: 0, bold: false },
  beneficiary_name: { left: 48, top: 96, font_size: 9, letter_spacing: 0, bold: false },
  beneficiary_account_number: { left: 48, top: 102, font_size: 9, letter_spacing: 30, bold: false },
  beneficiary_bank_name: { left: 48, top: 108, font_size: 9, letter_spacing: 0, bold: false },
  beneficiary_routing_number: { left: 146, top: 108, font_size: 9, letter_spacing: 18, bold: false },
  beneficiary_branch_name: { left: 48, top: 113, font_size: 9, letter_spacing: 0, bold: false },
  amount_figures: { left: 48, top: 119, font_size: 9, letter_spacing: 30, bold: false },
  amount_words: { left: 48, top: 125, font_size: 9, letter_spacing: 0, bold: false },
}

// Merge a stored overlay_config with defaults so missing keys fall back.
export const buildCoords = source =>
  Object.fromEntries(
    COORD_FIELDS.map(({ key }) => {
      const d = DEFAULT_COORDS[key]
      const s = source?.[key] ?? {}
      return [
        key,
        {
          left: s.left ?? d.left,
          top: s.top ?? d.top,
          font_size: s.font_size ?? d.font_size,
          letter_spacing: s.letter_spacing ?? d.letter_spacing,
          bold: s.bold ?? d.bold,
        },
      ]
    })
  )
